<div class="progress-container"></div>
<div class="container-fluid tab-body">
  <tabset #tabset>

    @for (tabz of tabs; track tabz) {
      <tab
        [heading]="tabz.title"
        [active]="tabz.active"
        (selectTab)="tabz.active = true"
        (deselect)="tabz.active = false">
        <div>
          @switch (tabz?.content) {
            <!--        <app-contracts-overview *ngSwitchCase="'CONTRACTS OVERVIEW'"></app-contracts-overview>-->
            @case ('WARRANTY SUMMARY') {
              <app-warrenty-summary [dealerName]="dealerName"></app-warrenty-summary>
            }
            @case ('DEALER INVOICE SUMMARY') {
              <app-invoice-summary [dealerName]="dealerName"></app-invoice-summary>
            }
            @case ('DEALER CREDIT NOTE SUMMARY') {
              <app-credit-note-summary [dealerName]="dealerName"
              ></app-credit-note-summary>
            }
            @case ('DEALER AGE BREAKDOWN') {
              <app-dealer-age [dealerName]="dealerName"></app-dealer-age>
            }
            @case ('FULL EXPORT') {
              <app-full-export></app-full-export>
            }
            @case ('FAILED UPLOAD EXPORT') {
              <app-failed-upload-export [hidden]="!isAdmin()"></app-failed-upload-export>
            }
          }
        </div>
      </tab>
    }

  </tabset>
</div>
